import { createFileRoute } from "@tanstack/react-router";
import { AmenityDetailPage } from "@/components/pages/AmenityDetailPage";

export const Route = createFileRoute("/amenities/$amenityId")({
  component: AmenityDetailPage,
});
